import type { CastMember } from '../../../mocks/movieDetails';

interface Props {
  cast: CastMember[];
  director: string;
  studio: string;
  awards?: string;
}

export default function CastSection({ cast, director, studio, awards }: Props) {
  return (
    <div className="space-y-8">
      {/* Director & Studio */}
      <div className="grid grid-cols-2 gap-4">
        <div className="bg-[#F5F1E8] rounded-xl p-4">
          <p className="text-xs text-gray-400 font-bold mb-1">المخرج</p>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center bg-[#C9A961]/15 rounded-full">
              <i className="ri-vidicon-line text-[#C9A961] text-sm" />
            </div>
            <p className="text-sm font-black text-gray-800">{director}</p>
          </div>
        </div>
        <div className="bg-[#F5F1E8] rounded-xl p-4">
          <p className="text-xs text-gray-400 font-bold mb-1">الاستوديو</p>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center bg-[#C9A961]/15 rounded-full">
              <i className="ri-film-line text-[#C9A961] text-sm" />
            </div>
            <p className="text-sm font-black text-gray-800 leading-tight">{studio}</p>
          </div>
        </div>
      </div>

      {/* Award */}
      {awards && (
        <div className="flex items-center gap-3 bg-[#C9A961]/10 border border-[#C9A961]/25 rounded-xl p-4">
          <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
            <i className="ri-trophy-line text-2xl text-[#C9A961]" />
          </div>
          <div>
            <p className="text-xs font-bold text-[#C9A961] mb-0.5">جائزة</p>
            <p className="text-sm font-bold text-gray-800">{awards}</p>
          </div>
        </div>
      )}

      {/* Cast */}
      <div>
        <h3 className="text-lg font-black text-gray-900 mb-4 flex items-center gap-2">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-user-star-line text-[#C9A961]" />
          </div>
          طاقم التمثيل
        </h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {cast.map((member, i) => (
            <div
              key={i}
              className="flex items-center gap-3 p-3 bg-[#FAFAF8] rounded-xl border border-gray-100 hover:border-[#C9A961]/30 transition-colors"
            >
              <img
                src={member.photo}
                alt={member.name}
                className="w-12 h-12 rounded-full object-cover object-top flex-shrink-0"
              />
              <div className="min-w-0">
                <p className="text-sm font-black text-gray-800 truncate">{member.name}</p>
                <p className="text-xs text-gray-400 truncate">{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
